import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { LocalizedText, Rows, LabeledSelect, Field, FormBlock } from 'labguard-cdk'
import { useQuery } from 'react-apollo'
import { GlobeIcon, LanguageIcon } from 'src/components/common'
import LocaleExamples from './LocaleExamples'

export const langsQuery = gql`
  query preferencesLangs {
    langs {
      id
      name
    }
  }
`

const localesQuery = gql`
  query preferencesLocales {
    locales {
      id
      i18n
    }
  }
`

function Preferences({ enabled, children, ...props }) {
  const { loading: langsLoading, data: { langs = [] } = {} } = useQuery(langsQuery)
  const { loading: localesLoading, data: { locales = [] } = {} } = useQuery(localesQuery)

  return (
    <FormBlock
      title={<LocalizedText id="WEB_SOFTWARE_PREFERENCES" />}
      loading={langsLoading || localesLoading}
      locked={!enabled}
      {...props}
    >
      <Rows layout="1 auto">
        <Rows layout="1">
          {children}
          <Field
            name="langId"
            component={LabeledSelect}
            topLabel={<LocalizedText id="WEB_LANGUAGE" />}
            icon={LanguageIcon}
          >
            {langs.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </Field>
          <Field
            name="localeId"
            component={LabeledSelect}
            topLabel={<LocalizedText id="WEB_FORMAT" />}
            icon={GlobeIcon}
          >
            {locales.map(({ id, i18n }) => (
              <LocalizedText key={id} id={i18n}>
                {label => <option value={id}>{label}</option>}
              </LocalizedText>
            ))}
          </Field>
        </Rows>

        <LocaleExamples />
      </Rows>
    </FormBlock>
  )
}

Preferences.propTypes = {
  enabled: PropTypes.bool,
  children: PropTypes.node,
}

export default Preferences
